module.exports = __webpack_public_path__ + "img/logo.2796586d.png";